import { HeadProps, PageProps, graphql } from 'gatsby'
import { Fragment } from 'react'

import { LeaderArticle } from '@/features/article-templates'
import { Seo } from '@/features/common/'
import {
  BoardSection,
  BodySection,
  GoFurtherSection,
  LeadershipSection,
  PageHero,
} from '@/features/page-sections'

const OurPeoplePage = ({
  data: { datoCmsOurPeoplePage: page },
}: PageProps<Queries.OurPeoplePageQuery>): JSX.Element => {
  return (
    <Fragment>
      <PageHero
        heading={page?.pageHeading}
        heroImage={page?.heroImage}
      />
      <section>
        <LeaderArticle
          data={page?.headOfSchool}
          layout="ON_PAGE"
        />
      </section>
      <LeadershipSection
        data={page?.leadership?.[0]}
        bgColor="GRAY"
      />
      <BoardSection data={page?.board?.[0]} />
      <BodySection
        data={page?.facultyStaff?.[0]}
        bgColor="RED"
      />
      {page?.goFurther?.[0] && (
        <GoFurtherSection data={page?.goFurther[0]} />
      )}
    </Fragment>
  )
}

export const Head = ({
  data: { datoCmsOurPeoplePage: page },
}: HeadProps<Queries.OurPeoplePageQuery>) => (
  <Seo seoMetaTags={page?.seoMetaTags} />
)

export const data = graphql`
  query OurPeoplePage {
    datoCmsOurPeoplePage {
      pageHeading
      heroImage {
        ...PageHero
      }
      headOfSchool {
        ...LeaderArticle
      }
      leadership {
        ...LeadershipSection
      }
      board {
        ...BoardSection
      }
      facultyStaff {
        ...BodySection
      }
      goFurther {
        ...GoFurtherSection
      }
      seoMetaTags {
        tags
      }
    }
  }
`

export default OurPeoplePage
